import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import Placement from '../../../api/models/placement';
import { getPlacements } from '../../../api/services/placementService';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';

type ViewState = {
    message?: string;
};

const ViewPlacements = () => {
    const columns = React.useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
                width: 200,
            },
            {
                id: 'division',
                Header: 'Divisions',
                accessor: (d: any) => d.placementDivisions.length === 0 ? 'Global' : d.placementDivisions.sort((a: any, b: any) => (a.division.name.toLowerCase() > b.division.name.toLowerCase()) ? 1 : -1).map((d: any) => d.division.name).join(', '),
            },
            {
                accessor: 'placementId',
                disableSortBy: true,
                Cell: () => {
                    return (
                        <div className='clearfix'>
                            <span className='float-right'>
                                <PencilIcon className="w-5 h-5 cursor-pointer" aria-hidden="true" />
                            </span>
                        </div>
                    );
                },
                wdith: 50,
                className: "hidden sm:table-cell"
            },
        ],
        []
    );

    const history = useHistory();
    const { state } = useLocation<ViewState>();
    const [Placements, setPlacements] = useState<Placement[]>([]);

    const { error, isPending } = useAsync({
        promiseFn: getPlacements,
        onResolve: (r) => {
            setPlacements(r.data.placements);
        },
    });

    if (error) return <LayoutError />;

    return (
        <Layout isLoading={isPending}>
            <Fragment>
                {state?.message && <Notification message={state?.message} />}
                <div className='mb-4 text-right'>
                    <Link className='btn' to='/admin/placements/new'>
                        Add Placement
                    </Link>
                </div>

                <DataTable
                    columns={columns}
                    data={Placements}
                    showPagination={true}
                    getRowProps={(row: any) => ({
                        onClick: () => history.push(`/admin/placements/${row.values.placementId}`),
                        className: "cursor-pointer hover:bg-gray-100",
                    })}
                />
            </Fragment>
        </Layout>
    );
};

export default ViewPlacements;
